var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PureComponent } from "react";
import { DerivedValue } from "./reactive";
var Component = (function (_super) {
    __extends(Component, _super);
    function Component(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { updates: 0 };
        _this._update = function () {
            _this._needsUpdate = true;
            _this.setState({ updates: _this.state.updates + 1 });
        };
        _this._listeners = [];
        _this._listen = function (fn) {
            var first = true;
            _this._listeners.push(new DerivedValue(function () {
                fn();
                if (first) {
                    first = false;
                }
                else {
                    _this._update();
                }
            }));
        };
        return _this;
    }
    Component.prototype.willMount = function (props) { };
    Component.prototype.componentWillMount = function () {
        var _this = this;
        this._listen(function () {
            _this._view = _this.view(_this.props);
        });
        this._listen(function () { return _this.willMount(_this.props); });
    };
    Component.prototype.didMount = function (props) { };
    Component.prototype.componentDidMount = function () {
        var _this = this;
        this._listen(function () { return _this.didMount(_this.props); });
    };
    Component.prototype.willUpdate = function (props) { };
    Component.prototype.componentWillUpdate = function (nextProps) {
        this._needsUpdate = true;
        this.willUpdate(nextProps);
    };
    Component.prototype.willUnmount = function (props) { };
    Component.prototype.componentWillUnmount = function () {
        this._listeners.forEach(function (l) { return l.stop(); });
        this.willUnmount(this.props);
    };
    Component.prototype.view = function (props) {
        return null;
    };
    Component.prototype.render = function () {
        if (this._needsUpdate) {
            this._view = this.view(this.props);
            this._needsUpdate = false;
        }
        return this._view;
    };
    return Component;
}(PureComponent));
export default Component;
//# sourceMappingURL=component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/reactive-magic/component.js
// module id = 12
// module chunks = 0